import cx from 'classnames';
import {useCallback, useRef, useState} from 'react';
import {HexColorPicker} from 'react-colorful';
import {Popover} from 'react-tiny-popover';

import './EyeDropper.sass';

export const EyeDropper = ({color, onChange, onConfirmColor, editorDisabled, className}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  const toggleVisibility = useCallback(() => {
    setIsVisible((prevState) => {
      if (prevState) {
        onConfirmColor();
      }
      return !prevState;
    });
  }, [onConfirmColor]);

  const handleColorChange = useCallback(
    (value) => {
      onChange(value);
    },
    [onChange]
  );

  const handleButtonClick = useCallback(() => {
    if (!editorDisabled) {
      toggleVisibility();
    }
  }, [editorDisabled, toggleVisibility]);

  return (
    <Popover
      ref={ref}
      isOpen={isVisible}
      positions={['top', 'bottom', 'left', 'right']}
      onClickOutside={toggleVisibility}
      content={<HexColorPicker color={color} onChange={handleColorChange} />}
      containerClassName={cx('eye_dropper', {
        [`${className}__eye-dropper`]: className,
      })}
      clickOutsideCapture
    >
      <button
        className="eye_dropper--button unstyled-button"
        onClick={editorDisabled ? undefined : handleButtonClick}
        disabled={editorDisabled}
        data-qa-id="step1-textcolor-add"
        type="button"
        aria-label="color select button"
      >
        <img
          alt="dropper icon"
          src="https://g0.evitecdn.com/create-flow/ui/color-picker-icon.png"
          className="eye-dropper__icon"
        />
      </button>
    </Popover>
  );
};
